<template>
  <div class="password_setting">
    <div class="setting_item">
      <van-field
        v-model.trim="update.alipayAccount"
        placeholder="请输入支付宝账号"
        :border="false"
      />
    </div>
    <div class="setting_item">
      <van-field
        v-model.trim="update.alipayName"
        placeholder="真实姓名"
        :border="false"
      />
    </div>

    <div class="btn_wrapper">
      <van-button
        round
        type="info"
        size="normal"
        color="#F93244"
        @click="handleUpdate"
        :disabled="!update.alipayAccount || !update.alipayName"
        class="update_btn"
        >保存修改</van-button
      >
    </div>
  </div>
</template>

<script>
import { accountUpdate } from '@/api';
export default {
  data() {
    return {
      update: {
        alipayAccount: '',
        alipayName: ''
      }
    };
  },
  mounted() {},
  methods: {
    handleUpdate() {
      const { update } = this;
      if (
        !/^(?:1[3-9]\d{9}|[a-zA-Z\d._-]*\@[a-zA-Z\d.-]{1,10}\.[a-zA-Z\d]{1,20})$/.test(
          update.alipayAccount
        )
      ) {
        return this.$toast.fail('请输入正确的支付宝账号');
      }
      accountUpdate(update).then((res) => {
        if (res.success) {
          this.$toast.success('修改成功');
          this.update = {};
        } else {
          this.$toast.fail(res.msg);
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.password_setting {
  background-color: #f7f8fa;
  min-height: 100vh;
  padding-top: 3.2vw;
  .setting_item {
    height: 14.933vw;
    margin-bottom: 3.2vw;
    .field_item {
      height: 14.933vw;
      margin-bottom: 4.267vw;
      display: flex;
      align-items: center;
      font-size: 4.533vw;
      color: rgba(0, 0, 0, 0.25);
      .code {
        font-size: 4.533vw;
        color: #f93244;
        padding: 6px 10px;
      }
      .code2 {
        font-size: 4.533vw;
        color: rgba(0, 0, 0, 0.45);
      }
    }
  }
  .btn_wrapper {
    display: flex;
    justify-content: center;
    .update_btn {
      margin-top: 62.533vw;
      width: 91.467vw;
      height: 11.733vw;
    }
  }
}
/deep/ .van-cell {
  height: 14.933vw;
  display: flex;
  align-items: center;
}
/deep/ .van-field__control {
  font-size: 4.533vw;
}
</style>
